export default __webpack_public_path__ + "static/media/search-black.d89bbd54.svg";